// Token storage. Backend issues a JWT, frontend stashes in localStorage.
// 401 from any API call → clear + redirect to /auth/login.

const TOKEN_KEY = 'al_token';
const USER_KEY = 'al_user';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t: string) {
  localStorage.setItem(TOKEN_KEY, t);
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function setStoredUser(u: unknown) {
  localStorage.setItem(USER_KEY, JSON.stringify(u));
}

export function getStoredUser<T = unknown>(): T | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
